import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import JudgeTime from '../../marketing_activity/utils';
import BudgetSubjectForm from '../components/budget_subject_table.vue';
import MaterialForm from '../components/material_table.vue';

formCreate.component('BudgetSubjectForm', BudgetSubjectForm);
formCreate.component('MaterialForm', MaterialForm);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      isControl: null,
      formFunctionCode: 'main_form',
      formParentCode: 'CRM20251124000000006',
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          },
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          },
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          },
        }],
      },
      fData: {},
      materialClassifyList: [],
      materialUnitList: [],
    };
  },

  async created() {
    await this.getDictSelect();
  },
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'actTime') { // 预计使用时间
        v.validate = {
          message: '预计使用时间不能为空',
          required: true,
          trigger: 'change',
        };
        v.props = {
          ...v.props,
          type: 'datetimerange',
          pickerOptions: this.pickerOptions,
          rangeSeparator: '至',
          startPlaceholder: '开始日期',
          endPlaceholder: '结束日期',
          unlinkPanels: true,
          align: 'right',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          defaultTime: ['00:00:00', '23:59:59'],
        };
        v.on = {
          change: this.onActTimeChange,
        };
      }

      if (v.field === 'budget') {
        v.props = {
          ...v.props,
          saveRef: this.saveBudgetRef,
          startTime: '',
          endTime: '',
          isControl: this.isControl !== 'no_control',
        };
        v.value = {
          data: [],
        };
        v.on = {
          ...v.on,
          change: this.onBudgetCode,
          clear: this.clearBudgetCode,
        };
      }
      if (v.field === 'reqVos') {
        v.on = {
          ...v.on,
          addTotal: this.addTotal,
        };
      }
      if (v.field === 'totalPrice') {
        v.props = {
          ...v.props,
          controls: false,
        };
      }
      if (v.field === 'attachVos') {
        v.props = {
          ...v.props,
          fileMsg: '请上传: pdf,docx,xlsx,ppt,png,jpg等类型',
        };
      }
      return v;
    },
    /**
     * 表单渲染完成后回调
     */
    async formComplete() {
      this.disabled(true, ['useCityCode', 'useDistrictCode']);
      const useProvinceCode = this.getRule('useProvinceCode');
      const useCityCode = this.getRule('useCityCode');
      const useDistrictCode = this.getRule('useDistrictCode');
      useProvinceCode.restful = '/mdm/mdmRegionController/selectStartWithProvince';
      useProvinceCode.optionsKey = { label: 'regionName', value: 'regionCode' };
      useProvinceCode.props.loading = true;
      useProvinceCode.props = {
        ...useProvinceCode.props,
        loading: true,
        filterable: true,
        remote: true,
        remoteParams: 'regionName',
      };

      useProvinceCode.on.change = (val) => {
        console.log('porr', val);
        console.log('useProvinceCode', useProvinceCode);

        this.setValue({
          useCity: '',
          useDistrict: '',
          useProvince: useProvinceCode.options.find((pitem) => pitem.regionCode === val).regionName,
        });
        if (!val) {
          this.disabled(true, ['useCityCode', 'useDistrictCode']);
        } else {
          this.disabled(true, ['useDistrictCode']);
          this.disabled(false, ['useCityCode']);
        }
      };

      useCityCode.restful = '/mdm/mdmRegionController/list';
      useCityCode.optionsKey = { label: 'regionName', value: 'regionCode' };
      useCityCode.restfulParamsGetValue = { parentCode: 'useProvinceCode' };
      useCityCode.refresh = true;
      useCityCode.props = {
        ...useCityCode.props,
        loading: true,
        filterable: true,
        remote: true,
        remoteParams: 'regionName',
      };
      useCityCode.on.change = (val) => {
        this.setValue({
          useDistrict: '',
          useCity: useCityCode.options.find((pitem) => pitem.regionCode === val).regionName,
        });
        if (!val) {
          this.disabled(true, ['useDistrictCode']);
        } else {
          this.disabled(false, ['useDistrictCode']);
        }
      };
      useDistrictCode.restful = '/mdm/mdmRegionController/list';
      useDistrictCode.optionsKey = { label: 'regionName', value: 'regionCode' };
      useDistrictCode.restfulParamsGetValue = { parentCode: 'useCityCode' };
      useDistrictCode.refresh = true;
      useDistrictCode.props = {
        ...useDistrictCode.props,
        loading: true,
        filterable: true,
        remote: true,
        remoteParams: 'regionName',
      };
      useDistrictCode.on.change = (val) => {
        this.setValue({
          useDistrict: useDistrictCode.options.find((pitem) => pitem.regionCode === val).regionName,
        });
      };
      if (this.formConfig.code === 'add') {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.setValue({
          createCode: userInfo.userName,
          createName: userInfo.fullName,
          createPosCode: userInfo.positionCode,
          createPosName: userInfo.positionName,
          createOrgCode: userInfo.orgCode,
          createOrgName: userInfo.orgName,
        });
      }
      if (this.formConfig.code === 'view' || this.formConfig.code === 'edit' || this.id) {
        await this.init();
      }
      this.isControl = await JudgeTime.getControlType();
      this.getControlConfig();
    },
    // 计算合计总金额
    addTotal(row) {
      this.setValue({
        totalPrice: row || 0,
      });
    },
    // 获取数据字典
    getDictSelect() {
      const params = [
        'tpm_material_classify',
        'material_base_unit',
      ];
      request.post('/mdm/mdmdictdata/batchDictSelect', params).then((res) => {
        if (res.success) {
          this.materialClassifyList = res.result.tpm_material_classify;
          this.materialUnitList = res.result.material_base_unit;
          const reqVos = this.getRule('reqVos');
          reqVos.props = {
            ...reqVos.props,
            materialClassifyList: this.materialClassifyList,
            materialUnitList: this.materialUnitList,
          };
        }
      });
    },
    // 获取管控配置
    getControlConfig() {
      if (!this.judgeTime) {
        this.judgeTime = new JudgeTime(this.formConfig.code !== 'add' ? {
          time: [
            `${this.formConfig.row.useStartTime}`,
            `${this.formConfig.row.useEndTime}`,
          ],
          model: this.getFormData(),
        } : null);
      }
    },
    saveBudgetRef(ref) {
      this.budgetRef = ref;
    },
    // 监听预算科目
    onBudgetCode() {},
    // 监听清空预算科目
    clearBudgetCode() {},
    // 时间格式化
    getTime(startTime, endTime) {
      return {
        startTime,
        endTime,
        useStartTime: startTime || '',
        useEndTime: endTime || '',
      };
    },

    // 格式化
    formateTime(val) {
      let time = null;
      if (val && Array.isArray(val) && val.length === 2) {
        const {
          useStartTime, useEndTime,
        } = this.getTime(val[0], val[1]);
        time = {
          useStartTime, useEndTime,
        };
      }
      return time;
    },
    // 改变活动时间
    onActTimeChange(val) {
      if (this.budgetRef) {
        this.budgetRef.deleteTable();
      }
      if (val && Array.isArray(val) && val.length === 2) {
        const startTime = val[0];
        const endTime = val[1];
        const budgetCode = this.getRule('budget');
        budgetCode.props = {
          ...budgetCode.props,
          startTime,
          endTime,
        };
        // 时间发生变化时，比较差异。删除不在活动时间内的预算
        if (this.budgetRef) {
          this.budgetRef.reset(startTime, endTime);
        }
      } else {
        const budgetCode = this.getRule('budget');
        budgetCode.props = {
          ...budgetCode.props,
          startTime: '',
          endTime: '',
        };
      }
    },
    // 提交
    async submit() {
      let params = this.getFormData();
      if (!params) return false;
      console.log('ffff___', params);
      let url = '/tpm/tpmactmaterialapply/save';
      const { row, code } = this.formConfig;
      const { actTime, budget, reqVos } = params;
      if (!actTime) return false;
      if (budget.data && budget.data.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择预算!',
        });
        return false;
      }
      if (reqVos && reqVos.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择物料!',
        });
        return false;
      }
      // 时间处理
      const time = this.formateTime(actTime);
      if (time) {
        params = { ...params, ...time };
      }
      const budgetCodes = [];
      (budget.data || []).forEach((item) => {
        budgetCodes.push(item.feeBudgetCode);
      });
      params.budgetCodes = budgetCodes || [];
      params.reqVos = (reqVos || []).map((v) => ({
        materialId: v.materialId,
        num: v.num,
        price: v.price,
      }));
      let isNum = null;
      isNum = (params.reqVos || []).find((v) => v.num === 0 || !v.num);
      if (isNum) {
        this.$message({
          type: 'error',
          message: '物料数量必须大于0!',
        });
        return false;
      }
      delete params.title1;
      delete params.title2;
      delete params.title3;
      delete params.budget;
      delete params.actTime;
      if (code === 'edit') {
        url = '/tpm/tpmactmaterialapply/update';
        params = { ...params, id: row.id, code: row.code };
      }
      const { success } = await request.post(url, params);
      if (success) {
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('onClose');
        this.$emit('onGetList');
      }
    },

    async init() {
      const { row } = this.formConfig;
      console.log(this.formConfig.row, 999);
      const data = await request.post('/tpm/tpmactmaterialapply/query', { id: this.formConfig.row.id || this.id || '' }).then((res) => (res.success ? res.result : []));
      // 处理时间
      data.actTime = [`${data.useStartTime}`, `${data.useEndTime}`];
      // 费用预算编码
      data.budget = {
        data: data.budgetRespVos || [],
      };
      data.reqVos = (data.respVos || []).map((v) => {
        const obj = v;
        obj.classifyName = ((this.materialClassifyList || []).find((v1) => v1.dictCode === obj.classify) || {}).dictValue || '';
        obj.unitName = ((this.materialUnitList || []).find((v1) => v1.dictCode === obj.unit) || {}).dictValue || '';
        return obj;
      });
      const budgetCode = this.getRule('budget');
      budgetCode.props = {
        ...budgetCode.props,
        startTime: data.useStartTime,
        endTime: data.useEndTime,
      };
      this.fData = data;
      this.setValue(data);
    },
  },
};
